import { Control, Controller } from "react-hook-form";
import { Tool } from "../AssistantDetailsContent";
import { QuickActionField } from "../QuickActionField";
import { NoxusFormEntryConfig } from "@/components/Spotflow/ConfigDrawer/ConfigDrawer";

export const BaseToolsFieldNCL = ({
  name,
  control,
  isDisabled,
  defaultValue,
  itemConfig,
  itemConfigByType,
}: {
  name: string;
  control: Control<Record<string, unknown>>;
  isDisabled?: boolean;
  defaultValue?: unknown;
  itemConfig?: Record<string, NoxusFormEntryConfig>;
  itemConfigByType?: Record<string, Record<string, NoxusFormEntryConfig>>;
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => {
        const value = field.value as Tool[] | undefined;
        return (
          <QuickActionField
            tools={value}
            onToolsChange={field.onChange}
            isDisabled={isDisabled}
            itemConfig={itemConfig}
            itemConfigByType={itemConfigByType}
          />
        );
      }}
    />
  );
};
